export default __webpack_public_path__ + "static/media/bannerimg.551392d2.svg";